export enum SIDEBAR_ACTION_TYPES {
  SHOW_ACCOUNT = 'SHOW_ACCOUNT',
  SHOW_CART = 'SHOW_CART',
  SHOW_LOGIN = 'SHOW_LOGIN',
  SHOW_REGISTER = 'SHOW_REGISTER',
  SHOW_PROFILE = 'SHOW_PROFILE',
}
